import ReportExample from './ReportExampleContainer.vue';

export { ReportExample };



// WEBPACK FOOTER //
// ./src/modules/home/reportExample/index.js